












































































import {
  ShowManagementSearchTitleDTO,
  ShowManagementService as showApi,
} from "@/common/api";
import QNotify from "@/common/qNotify";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import QMultiSelect from "@/components/common/qMultiSelect.vue";
import PaginateModel from "@/model/paginate";
import { STATUS, STATUS_NAME } from "@/model/releaseSetting";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "ShowListComponent",
  components: {
    QSearch,
    QPaginate,
    QTableHeader,
    QMultiSelect,
  },
})
export default class ShowListComponent extends Vue {
  public shows = [];
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public headers = [];

  public initHeaders = [
    { id: "created_at", name: "作成日", order: "desc" },
    { id: "post_date", name: "公開日時", order: "" },
    { id: "created_by", name: "作成者", order: "" },
    { id: "title", name: "品評会名" },
    { id: "count", name: "回数" },
    { id: "open_status", name: "状態", order: "" },
    { id: "", name: "" },
  ];

  public initSearch = {
    titles: ["all"],
    counts: ["all"],
    sort: "created_at",
    direction: "desc",
    perPage: 30,
    currentPage: 1,
  };

  public searchParams: any = {};
  public titles: ShowManagementSearchTitleDTO[] = [];
  public counts = [];

  public selectedAllTitle = { id: "all", name: "すべての品評会" };
  get titleSearchOption() {
    return [...[this.selectedAllTitle], ...this.titles];
  }
  public selectedAllCount = { id: "all", name: "すべての大会" };
  get countSearchOption() {
    return [...[this.selectedAllCount], ...this.counts];
  }

  public async mounted() {
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));
    this.getSearchParams();
    this.initalSearch();
    this.filterData();
  }

  public async getSearchParams() {
    const result = await showApi.adminShowListSearchParams({});
    this.titles = result.data.search_params.titles.map((item) => {
      return { id: item.id, name: item.name };
    });
    this.counts = result.data.search_params.counts.map((item) => {
      return { id: item, name: item };
    });
  }

  public initalSearch(): void {
    const query = this.$router.currentRoute.query;
    if (query.titles) {
      query.titles = Array.isArray(query.titles)
        ? query.titles
        : [query.titles];
    }
    if (query.counts) {
      query.counts = Array.isArray(query.counts)
        ? query.counts
        : [query.counts];
    }

    this.searchParams = {
      ...this.initSearch,
      ...query,
    };
  }

  public filterData(clear = false, addition = {}): void {
    let { name, params, query } = this.$router.currentRoute;
    if (clear) {
      query = {};
    }
    query = {
      ...this.searchParams,
      ...query,
      ...addition,
    };

    this.$router
      .replace({ name, params, query })
      .catch((error) => {
        console.error(error);
      });
    this.doSearch(query);
  }

  public doSearch(query: any = {}): void {
    this.getList(query);
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public async getList(query) {
    let message: any;
    try {
      if (query.titles && query.titles.includes("all")) {
        query.titles = [];
      }

      if (query.counts && query.counts.includes("all")) {
        query.counts = [];
      }
      const result = await showApi.adminShow(query);
      this.pagination = new PaginateModel({
        page: result.data.paginator.currentPage,
        pageCount: result.data.paginator.lastPages,
        start: result.data.paginator.currentPage,
        end: result.data.paginator.lastPages,
        count: result.data.paginator.total,
      });
      this.shows = result.data.shows;
    } catch (error) {
      message = error.body.message;
      QNotify.error({
        text: message,
      });
    }
  }

  public clear() {
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));
    this.$router.replace({ query: {} });
    this.doSearch();
  }

  public resetSearch() {
    this.clearSearchParams();
    this.filterData(true);
  }

  public clearSearchParams() {
    this.searchParams = { ...this.initSearch };
  }

  public getStatus(item): string {
    if (item.open_status === STATUS.RELEASE) {
      const date = new Date(item.post_date);
      const today = new Date();
      if (date > today) {
        return STATUS_NAME[STATUS.WAIT];
      }
    }
    return STATUS_NAME[item.open_status];
  }

  public async filterCount() {
    let type = this.searchParams.titles;
    if (type.includes("all")) {
      type = [];
    }
    const result = await showApi.adminShowListSearchParams({ type });
    this.counts = result.data.search_params.counts.map((item) => {
      return { id: item, name: item };
    });
  }
}
